import React from 'react';
import './RecentSearches.css';

const RecentSearches = ({ history, onSelect, onRemove, onClear }) => {
  if (!history || history.length === 0) return null;

  const formatLabel = (item) => {
    if (item.address) return item.address;
    if (item.gush && item.helka) return `גוש ${item.gush} חלקה ${item.helka}`;
    return 'חיפוש לא ידוע';
  };

  return (
    <div className="recent-searches">
      <div className="recent-searches-header">
        <span className="recent-searches-title">
          <i className="fi fi-rr-time-past"></i>
          חיפושים אחרונים
        </span>
        <button
          type="button"
          className="recent-searches-clear"
          onClick={onClear}
          title="נקה היסטוריה"
        >
          נקה הכל
        </button>
      </div>
      <div className="recent-searches-list">
        {history.map((item) => (
          <div key={item.timestamp} className="recent-search-chip">
            <button
              type="button"
              className="recent-search-chip-btn"
              onClick={() => onSelect(item)}
              title={formatLabel(item)}
            >
              <span className="recent-search-chip-text">{formatLabel(item)}</span>
              {item.municipality && item.searchMode === 'parcel' && (
                <span className="recent-search-chip-meta">{item.municipality}</span>
              )}
            </button>
            <button
              type="button"
              className="recent-search-chip-remove"
              onClick={(e) => { e.stopPropagation(); onRemove(item.timestamp); }}
              title="הסר"
              aria-label="הסר מהיסטוריה"
            >
              <i className="fi fi-rr-cross-small"></i>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentSearches;
